/**
* Dtails+ Accept terms and conditions
*/

function fnDtailsCartTerms(event, action, status) {
  var cartTerms = event.closest('form').querySelector('dtails-cart-terms');
  if (cartTerms) {
    var cartTermsDrawer = cartTerms.querySelector('[data-dtails-cart-terms-drawer]'),
        orderRecap = document.querySelector('.cart-order__recap');
    if (action == 'open') {
      cartTermsDrawer.classList.add('dtails-cart-terms-drawer--opened');
      if (orderRecap) orderRecap.style.position = "relative";
    } else if (action == 'close') {
      cartTermsDrawer.classList.remove('dtails-cart-terms-drawer--opened');
      if (orderRecap) orderRecap.style.position = "sticky";
    }

    if (status == 'accept') {
      var cartTermsDrawerCheckbox = cartTerms.querySelector('[data-dtails-cart-terms-checkbox]');
      if (cartTermsDrawerCheckbox) cartTermsDrawerCheckbox.checked = true;
      localStorage.setItem('theme:cart-terms-accepted', 'true');
    }
  }
}

var DtailsCartTerms = class extends HTMLElement {
  constructor() {
    super();
    document.addEventListener('submit', this._onSubmit);
    this.addEventListener("click", this._onClick);
    if (localStorage.getItem('theme:cart-terms-accepted') == 'true' ) {
      fnDtailsCartTerms(this, '', 'accept');
    }
  }

  _onClick(event) {
    if (event.target.closest('[data-dtails-cart-terms-drawer-link]')) {
      fnDtailsCartTerms(event.target, 'open');
      event.preventDefault();
    } else if (event.target.closest('[data-dtails-cart-terms-drawer-close]')) {
      fnDtailsCartTerms(event.target, 'close');
      event.preventDefault();
    } else if (event.target.closest('[data-dtails-cart-terms-accept-button]')) {
      fnDtailsCartTerms(event.target, 'close', 'accept');
      event.preventDefault();
    } else {
      return;
    }
  }

  _onSubmit(event) {
    const submit = event.target.querySelector('button');
    const termsCartTerms = submit.closest('form').querySelector('dtails-cart-terms');
    if (!termsCartTerms) return;

    const termsCheckbox = termsCartTerms.querySelector('[data-dtails-cart-terms-checkbox]');

    if (submit.getAttribute('name') === 'checkout' && termsCheckbox) {
      if (termsCheckbox.checked) {
        localStorage.setItem('theme:cart-terms-accepted', 'true');
      } else {
        fnDtailsCartTerms(event.target, 'open');
        submit.setAttribute("aria-busy", "false");
        event.preventDefault();
        return false;
      }
    }
  }

};
if (!window.customElements.get("dtails-cart-terms") && window.themeVariables.settings.dtailsCartTerms) {
  window.customElements.define("dtails-cart-terms", DtailsCartTerms);
}

export { DtailsCartTerms };

if (document.querySelector('.custom-klaviyo-backinstock-btn') && document.getElementById("closeModal") && document.getElementById("backInStockForm")) {
  document.querySelector('.custom-klaviyo-backinstock-btn').addEventListener('click', function(e) {
    e.preventDefault();
    document.getElementById("backInStockModal").style.display = "block";
  });
  let formId = document.querySelector('.custom-klaviyo-backinstock-btn').getAttribute('form');
  document.forms[formId]?.addEventListener("variant:change", function(e) {
    let vId = e.detail.variant.id;
    document.getElementById("backInStockModal").setAttribute('data-vid', vId);
    document.querySelector(".bis-product-title").innerText = e.detail.variant.name;
    if (e.detail.variant.available) {
      document.getElementById("subscriptionSuccess").style.display = "none";
      document.querySelector('.custom-klaviyo-backinstock-btn').classList.remove('active');
    } else {
      document.getElementById("subscriptionSuccess").style.display = "none";
      document.querySelector('.custom-klaviyo-backinstock-btn').classList.add('active');
    }
  });

  document.getElementById("closeModal").addEventListener("click", function() {
    document.getElementById("backInStockModal").style.display = "none";
  });

  document.getElementById("backInStockForm").addEventListener("submit", function(event) {
    event.preventDefault();

    const email = document.getElementById("bis-email").value;
    const variantId = document.getElementById("backInStockModal").getAttribute('data-vid');
    const publicApiKey = document.getElementById("backInStockModal").getAttribute('data-key');
    const listId = document.getElementById("backInStockModal").getAttribute('data-list');
    let subscribeToList = false;
    if (document.getElementById("subscribe-list")) {
      subscribeToList = document.getElementById("subscribe-list").checked;
    }
    if (!email || !variantId || !publicApiKey) {
      alert("There was an error. Please try again.");
      return;
    }

    const payload = {
      "data": {
        "type": "back-in-stock-subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          },
          "channels": ["EMAIL"],
        },
        "relationships": {
          "variant": {
            "data": {
              "type": "catalog-variant",
              "id": `$shopify:::$default:::${variantId}`
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "revision":"2024-06-15"
      },
      body: JSON.stringify(payload),
    };

    fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${publicApiKey}`,requestOptions)
      .then(result => {
        console.log(result);
        if (result.ok) {
          document.getElementById("subscriptionSuccess").style.display = "block";

          // If checkbox is checked, subscribe to the list
          if (subscribeToList && listId) {
            subscribeToKlaviyoList(email, publicApiKey, listId);
          }
        } else {
          document.getElementById("subscriptionSuccess").style.display = "none";
          alert("There was an error. Please try again later.");
        }
      })
      .catch(error => alert("There was an error. Please try again later."));
  });

  function subscribeToKlaviyoList(email, publicApiKey, listId) {
    const payload = {
      "data": {
        "type": "subscription",
        "attributes": {
          "profile": {
            "data": {
                "type": "profile",
                "attributes": {
                    "email": email,
                }
            }
          }
        },
        "relationships": {
          "list": {
            "data": {
              "type": "list",
              "id": listId
            }
          }
        }
      }
    }

    var requestOptions = {
      method: 'POST',
      headers: {
        "Content-Type": "application/vnd.api+json",
        revision: '2024-10-15.pre',
      },
      body: JSON.stringify(payload),
    };
    
    fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${publicApiKey}`, requestOptions)
      .then(res => res.json())
      .then(res => console.log(res))
      .catch(err => console.error(err));
  }  
}

document.addEventListener("DOMContentLoaded", function() {
  if (document.querySelector('.variant-picker-custom') && window.currentSizeArr) {
    let sizeArr = window.currentSizeArr;
    // Check if all items have the same suffix
    const suffix = sizeArr[0].match(/[^\d\s+-]+$/)?.[0];
    const allSameSuffix = sizeArr.every(item => item.endsWith(suffix));

    if (!allSameSuffix) {
      // console.log("Suffix mismatch, keeping original order:", sizeArr);
      return;
    }

    // Extract and sort based on numeric values
    const sortedArr = sizeArr.slice().sort((a, b) => {
      const getValue = (str) => {
        if (str.includes('-')) {
          return parseInt(str.split('-')[0], 10);
        } else if (str.includes('+')) {
          return parseInt(str, 10) + 1; // prioritize over ranges
        }
        return parseInt(str, 10);
      };

      return getValue(a) - getValue(b);
    });

    console.log("Sorted Array:", sortedArr);
    // Apply order styles to labels based on sorted array
    const container = document.querySelector('.variant-picker-custom [data-option-selector][option-type="size"]');
    if (container) {
      const labels = Array.from(container.querySelectorAll('label'));

      sortedArr.forEach((value, index) => {
        const matchingLabel = labels.find(label => label.textContent.trim() === value);
        if (matchingLabel) {
          matchingLabel.style.order = index;
        }
      });

      // Ensure remaining items (if any) are assigned a default order
      labels.forEach((label, index) => {
        if (!sortedArr.includes(label.textContent.trim())) {
          label.style.order = sortedArr.length + index;
        }
      });
    }
  }

  // Gift wrap: refresh cart after adding giftwrap to update correct property
  document.addEventListener("cartUpdates", function() {
    document.dispatchEvent(new CustomEvent("cart:refresh"));
  });
});